const CLOSE_MODAL = 'alt_art/CLOSE_MODAL'
const OPEN_MODAL = 'alt_art/OPEN_MODAL'

const initialState = {
  card: undefined,
  isOpen: false,
}

const alternateArt = (state = initialState, action) => {
  switch (action.type) {
    case CLOSE_MODAL:
      return { ...state, isOpen: false }
    case OPEN_MODAL:
      return { ...state, card: action.card, isOpen: true }
    default:
      return state
  }
}

export const closeModal = () => ({ type: CLOSE_MODAL })

export const openModal = (card) => ({ card, type: OPEN_MODAL })

export default alternateArt
